<script>
import { required } from 'vuelidate/lib/validators'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Indicators from './indicators'

import axios from 'axios'

export default {
	page: {
		title: 'All Indicators',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Indicators },
	data() {
		return {
			title: 'All Indicators',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Indicators',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Indicators />
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
